import React from 'react';
import { useTranslation } from "react-i18next";

import { ReactComponent as InfoIcon } from 'assets/icons/ico_info_circle_blue.svg';
import CommunitiesItem from './communitiesItem';

const CommunitiesTable = ({ communities, setCommunities }) => {
    const { t } = useTranslation();

    if (!communities) {
        return (null);
    }

    return (
        <>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead className=''>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6 whitespace-nowrap">{t('communitiesTable.name')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('communitiesTable.description')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('communitiesTable.numberOfMembers')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {communities && communities.length > 0 && communities.map((community, i) => {
                            return (<CommunitiesItem 
                                        key={i} 
                                        community={community} 
                                        communities={communities} 
                                        setCommunities={setCommunities} />)
                        })}
                        {communities && communities.length < 1 &&
                            <tr className="h-16">
                                <td className="text-center" colSpan={4}>
                                    <div className="flex pl-6 gap-3 flex-row items-center justify-left">
                                        <InfoIcon className="h-6 w-6" />
                                        <span>{t('communitiesTable.noCommunities')}</span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default CommunitiesTable;